const alertFragment = `
fragment Alert on EventContentAlert {
  id
  message
  event_content_alert_template {
    id
    label
    event_content_alert_type {
        id
        name
    }
  }
  creation_datetime
  creation_user {
    id
    name
  }
}`;

export const indexQuery = `
${alertFragment}

query EventContentAlerts($eventContentId: ID!){
  eventContentAlerts(filters: {eventContent: $eventContentId}) {
    ...Alert
  }
}`;

export const sendAlert = `
${alertFragment}

mutation sendAlert(
  $eventContentId: ID!
  $template: ID!
  $message: String!
  $recipients: [ID]!
  $additional_recipients: [String]!
) {
  createEventContentAlert(
    event_content: $eventContentId
    event_content_alert_template: $template
    message: $message
    recipients: $recipients
    additional_recipients: $additional_recipients
  ) {
    ...Alert
  }
}`;
